import get from "lodash/get"

// Позволяет забрать из стора статусы для модели
export const selectStatusesList = state => {
  return get(state, `statusModel.list`)
}
